export default class FileHelper {
    public static getBase64(file: File): Promise<string> {
        const reader = new FileReader()

        return new Promise((res, rej) => {
            reader.readAsDataURL(file)
            reader.onload = () => {
                res(reader.result as string)
            }
            reader.onerror = (e) => {
                rej(e)
            }
        })
    }
    public static getFileFromUrl(
        src: string,
        fileName: string,
        mimeType: string
    ) {
        return fetch(src)
            .then(function (res) {
                return res.arrayBuffer()
            })
            .then(function (buf) {
                return new File([buf], fileName, { type: mimeType })
            })
    }
}
